<template>
  <div class="bg-contain common-blue-contain" :class="$style['el-main']">
    <div class="breadcrumb-tilte">{{ $t('systemManagement') }} > {{ $t('RoleManagement') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('roleName')">
            <el-input v-model="formInline.userName" clearable :placeholder="$t('roleName')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('helpFromExperts')">
            <el-select
              v-model="formInline.sosExperts"
              clearable
              :placeholder="$t('helpFromExperts')"
              :popper-append-to-body="false"
            >
              <el-option :label="$t('ContainChild')" value="1"></el-option>
              <el-option :label="$t('NoContainChild')" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList" class="serachBtn">{{ $t('query') }}</el-button>
            <el-button type="primary" @click="add" v-has="'sys:new:setting:system:role:add'" class="add-btn">{{
              $t('newlyAded')
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-box">
        <el-table :data="tableData" style="width: 100%;" @sort-change="sortChange">
          <el-table-column
            type="index"
            :index="indexMethod"
            :label="$t('SerialNo')"
            align="center"
            width="80"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            :label="$t('roleName')"
            width="250"
            sortable="name"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            prop="sosExperts"
            :label="$t('helpFromExperts')"
            width="180"
            sortable="sosExperts"
            :sort-orders="['ascending', 'descending']"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.sosExperts == 1">{{ $t('ContainChild') }}</span>
              <span v-else>{{ $t('NoContainChild') }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="features" :label="$t('rolePermissions')" :formatter="fileData" align="left">
          </el-table-column>
          <el-table-column
            :label="$t('operationh')"
            width="140"
            align="center"
            v-has="'sys:new:setting:system:role:edit' || 'sys:new:setting:system:role:del'"
          >
            <template slot-scope="scope">
              <span
                class="editClick"
                @click="RoleEditHandleClick(scope.row)"
                v-has="'sys:new:setting:system:role:edit'"
                v-if="scope.row.editable == 1"
                >{{ $t('edit') }}</span
              >
              <span
                class="editClick"
                @click="delRole(scope.row)"
                v-has="'sys:new:setting:system:role:del'"
                v-if="scope.row.editable == 1"
                >{{ $t('delete') }}</span
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      class="roleDialog common-blue-contain"
      :append-to-body="true"
      :title="userDialog ? $t('aewRole') : $t('editRole')"
      :visible.sync="newUserDialogTableVisible"
      :close-on-click-modal="false"
      width="540px"
    >
      <el-form :model="newRoleForm" :rules="rules" ref="ruleForm">
        <el-form-item :label="$t('roleName')" :label-width="formLabelWidth" :required="true">
          <el-input
            v-model="newRoleForm.name"
            clearable
            autocomplete="off"
            :placeholder="$t('pleaseEnter') + $t('roleName')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('helpFromExperts')" :label-width="formLabelWidth" :required="true">
          <el-radio-group v-model="newRoleForm.sosExperts">
            <el-radio :label="1" :value="1">{{ $t('ContainChild') }}</el-radio>
            <el-radio :label="0" :value="0">{{ $t('NoContainChild') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('bindMenu')" :label-width="formLabelWidth" class="menu-tree" :required="true">
          <el-tree
            ref="tree"
            :data="menuList"
            :default-checked-keys="checkedList"
            show-checkbox
            node-key="id"
            :check-strictly="true"
            @check="nodeClick"
            :props="defaultProps"
          >
          </el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormUser('ruleForm')">{{ $t('determine') }}</el-button>
        <el-button @click="newUserDialogTableVisible = false">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { errorCollection } from '@/api/dmp/dmpCollection'
export default {
  data() {
    return {
      // 查询表单参数
      formInline: {
        userName: '',
      },
      tableData: [],
      // 菜单列表
      menuList: [],
      // 选择的菜单与权限
      checkedList: [],
      // 显示新增/编辑角色弹窗
      newUserDialogTableVisible: false,
      // 新增/编辑角色 表单参数
      newRoleForm: {
        name: '',
        sosExperts: 1,
      },
      formLabelWidth: '150px',
      // 新增/编辑角色 标题文字显示
      userDialog: true,
      newUserDialogTableVisibleBefore: null,
      fileData(row) {
        let arr = []
        row.featuresTree.forEach(item => {
          let parentItem = ''
          if (item.checked) {
            parentItem = `【${item.name}】`
          }
          let hasChildren = false
          if (item.children) {
            item.children.forEach(it => {
              if (it.checked) {
                let strItem = `【${it.name}】`
                arr.push(strItem)
                hasChildren = true
              }
            })
          }
          if (!hasChildren) {
            arr.push(parentItem)
          }
        })
        return arr.join('')
      },
      defaultProps: {
        children: 'children',
        label: 'name',
        disabled: 'disabled',
      },
      rules: {
        name: [{ required: true, message: this.$t('pleaseEnter') + this.$t('roleName'), trigger: 'blur' }],
      },
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
    }
  },
  methods: {
    // 点击表头排序
    sortChange({ column, prop, order }) {
      this.formInline.sortColName = !order ? null : column.sortable
      this.formInline.useAsc = order === 'descending' ? 0 : 1
      this.getList()
    },
    nodeClick(currentObj, treeStatus) {
      // 用于：父子节点严格互不关联时，实现单向关联。
      let selected = treeStatus.checkedKeys.indexOf(currentObj.id) // -1未选中,>=0为选中
      // 选中
      if (selected !== -1) {
        // 子节点只要被选中父节点就被选中
        this.selectedParent(currentObj)
        // 统一处理子节点为相同的勾选状态
        this.uniteChildSame(currentObj, true)
      } else {
        // 未选中 处理子节点全部未选中
        if (currentObj.children !== null) {
          this.uniteChildSame(currentObj, false)
        }
      }
    },
    uniteChildSame(treeList, isSelected) {
      this.$refs.tree.setChecked(treeList.id, isSelected)
    },
    // 统一处理父节点为选中
    selectedParent(currentObj) {
      let currentNode = this.$refs.tree.getNode(currentObj)
      if (currentNode.parent.key !== undefined) {
        this.$refs.tree.setChecked(currentNode.parent, true)
        this.selectedParent(currentNode.parent)
      }
    },
    getList() {
      this.currentPage = 1
      this.search()
    },
    search() {
      let params = {
        name: this.formInline.userName,
        systemType: 'new',
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
        sosExperts: this.formInline.sosExperts
      }
      getRoles(params)
        .then(res => {
          if (res.state === 0) {
            this.tableData = res.data.list
            this.totalData = res.data.total
          }
        })
        .catch(res => {
          console.log(res)
        })
    },
    // 新增角色
    add() {
      this.userDialog = true
      this.checkedList = []
      this.getMenu()
      this.newUserDialogTableVisible = true
      this.newRoleForm = {
        name: '',
        sosExperts: 1,
      }
    },
    // 获取菜单列表
    getMenu() {
      getMenu({ systemType: 'new' })
        .then(res => {
          if (res.state === 0) {
            this.menuList = res.data
            if (this.menuList) {
              this.menuList.forEach(item => {
                if (item.disabled) {
                  this.checkedList.push(item.id)
                }
              })
            }
          }
        })
        .catch(res => {
          console.log(res)
        })
    },
    // 提交新增角色
    submitFormUser(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let NodesArr = this.$refs.tree.getCheckedNodes()
          let idArr = []
          for (let item of NodesArr) {
            idArr.push(item.id)
          }
          if (this.newRoleForm.name === '') {
            this.$message({
              type: 'error',
              message: this.$t('pleaseEnter') + this.$t('roleName'),
            })
            errorCollection('设置》角色管理', '新增/编辑角色', {
              status: 200,
              data: { state: -1, msg: '请输入角色名称' },
            })
            return
          } else if (idArr.length === 0) {
            this.$message({
              type: 'error',
              message: this.$t('bindatLeastMenu'),
            })
            errorCollection('设置》角色管理', '新增/编辑角色', {
              status: 200,
              data: { state: -1, msg: '请至少绑定一个菜单' },
            })
            return
          }
          if (this.userDialog) {
            let param = {
              name: this.newRoleForm.name,
              sosExperts: this.newRoleForm.sosExperts,
              featureIds: idArr,
            }
            this._saveAddRole(param)
          } else {
            let param = {
              id: this.newRoleForm.id,
              name: this.newRoleForm.name,
              sosExperts: this.newRoleForm.sosExperts,
              featureIds: idArr,
            }
            this._saveEditRole(param)
          }
        }
      })
    },
    _saveAddRole(param) {
      saveRole(param).then(res => {
        if (res.state === 0) {
          this.newUserDialogTableVisible = false
          this.$message({
            type: 'success',
            message: this.$t('AddSuccess'),
          })
          this.search()
        }
      })
    },
    _saveEditRole(param) {
      editRole(param).then(res => {
        if (res.state === 0) {
          this.search()
          this.$message({
            type: 'success',
            message: this.$t('MmodificationSucceeded'),
          })
          this.newUserDialogTableVisible = false
          let roleIds = sessionStorage.getItem('roleIds')
          if (roleIds) {
            roleIds = roleIds.split(',')
            if (roleIds.indexOf(param.id) > -1) {
              this.refreshToken()
            }
          }
        }
      })
    },
    // 删除角色
    delRole(row) {
      this.$confirm(this.$t('deleteThisRole'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        delRole(row).then(res => {
          if (res.state === 0) {
            this.search()
            this.$message({
              type: 'success',
              message: this.$t('deleteSuccess'),
            })
          }
        })
      })
    },
    // 编辑角色
    RoleEditHandleClick(row) {
      this.userDialog = false
      this.checkedList = []
      this.newUserDialogTableVisibleBefore = Object.assign({}, row)
      this.newUserDialogTableVisible = true
      this.$nextTick(() => {
        this.newRoleForm = this.newUserDialogTableVisibleBefore
        this.menuList = this.newRoleForm.featuresTree
        if (this.newRoleForm.features) {
          for (let item of this.newRoleForm.features) {
            this.checkedList.push(item.id)
          }
        }
      })
    },
    getFeature() {
      getFeature()
        .then(res => {
          if (res.state === 0) {
            let codeData = []
            for (let item of res.data) {
              codeData.push(item.code)
            }
            sessionStorage.setItem('featureCode', codeData)
          }
        })
        .catch(res => {
          console.log(res)
        })
    },
    refreshToken() {
      let params = {
        refresh_token: getSession('refresh_token'),
        grant_type: 'refresh_token',
      }
      refreshToken(params)
        .then(_res => {
          let state = _res.state
          if (state === 0) {
            let res = _res
            sessionStorage.setItem('featureCode', res.featureCode)
            setSession('access_token', res.token_type + ' ' + res.access_token)
            setSession('refresh_token', res.refresh_token)
            setSession('expireTime', res.expiration)
          }
        })
        .catch(res => {
          console.log(res)
        })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    },
    indexMethod(index) {
      return index + 1
    },
  },
  mounted() {
    this.search()
  },
}
import { getRoles, getMenu, saveRole, editRole, delRole, getFeature } from '@/api/rolesManage'
import { setSession, getSession } from '@/api/common'
import { refreshToken } from '@/api/login'
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
>>>.el-table
  height 640px
  min-height 480px;/* no */
>>>.el-popper
 width 100%!important
.base_main
  .title
    font-size 16px
    margin-bottom 28px
  .main
    .user_input
      margin-top 10px
      width 100px
      margin-left 10px
    .el-button
      margin-left 10px
    .pagination
      float right
      margin-top 1%
.menu-tree
  .el-tree
    max-height 300px
    overflow auto
  .el-tree::-webkit-scrollbar
    display none
    scrollbar-width none
.bg-contain .common-table-cnt .table-box /deep/ .el-table {
  height: 630px !important
}
.common-blue-contain
  .el-pagination
    margin-top 18px
</style>
<style module lang="stylus" scoped>
.el-main
  background var(--el-main-background)
</style>
